import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const TextProcessorConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const operation = node.data.config.operation || 'uppercase';

  const operations = [
    { value: 'uppercase', label: 'Nagybetűs', icon: '🔤', desc: 'Szöveg nagybetűssé alakítása' },
    { value: 'lowercase', label: 'Kisbetűs', icon: '🔡', desc: 'Szöveg kisbetűssé alakítása' },
    { value: 'trim', label: 'Szóközök eltávolítása', icon: '✂️', desc: 'Elejéről és végéről' },
    { value: 'replace', label: 'Csere', icon: '🔄', desc: 'Szövegrész cseréje' },
    { value: 'split', label: 'Felosztás', icon: '📋', desc: 'Szöveg felosztása listára' }
  ];

  return (
    <div className="space-y-3">
      <div>
        <label className={commonStyles.label}>
          Szöveg művelet
        </label>
        <div className="grid grid-cols-1 gap-2">
          {operations.map((op) => (
            <button
              key={op.value}
              onClick={() => updateConfig('operation', op.value)}
              className={`flex items-center p-3 rounded-md border text-sm transition-all ${
                operation === op.value
                  ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300'
                  : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:border-gray-400 dark:hover:border-gray-500'
              }`}
            >
              <span className="text-lg mr-3">{op.icon}</span>
              <div className="flex-1 text-left">
                <div className="font-medium">{op.label}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">{op.desc}</div>
              </div>
              {operation === op.value && (
                <span className="text-primary-500">✓</span>
              )}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className={commonStyles.label}>
          Feldolgozandó szöveg
        </label>
        <textarea
          value={node.data.config.text || ''}
          onChange={(e) => updateConfig('text', e.target.value)}
          className={commonStyles.textarea}
          rows={3}
          placeholder="{{email_body}} vagy fix szöveg"
        />
      </div>

      {operation === 'replace' && (
        <div className="space-y-2">
          <div>
            <label className={commonStyles.smallLabel}>Keresendő szöveg</label>
            <input
              type="text"
              value={node.data.config.find || ''}
              onChange={(e) => updateConfig('find', e.target.value)}
              className={commonStyles.input}
              placeholder="régi szöveg"
            />
          </div>
          <div>
            <label className={commonStyles.smallLabel}>Csere szöveg</label>
            <input
              type="text"
              value={node.data.config.replace || ''}
              onChange={(e) => updateConfig('replace', e.target.value)}
              className={commonStyles.input}
              placeholder="új szöveg"
            />
          </div>
        </div>
      )}

      {operation === 'split' && (
        <div>
          <label className={commonStyles.smallLabel}>Elválasztó karakter</label>
          <input
            type="text"
            value={node.data.config.delimiter || ','}
            onChange={(e) => updateConfig('delimiter', e.target.value)}
            className={commonStyles.input}
            placeholder=","
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Ezzel a karakterrel osztja fel a szöveget
          </p>
        </div>
      )}

      <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md p-3">
        <div className="text-xs text-gray-600 dark:text-gray-400">
          <strong>Eredmény változó:</strong> <code>result</code>
          <br />
          <strong>Eredeti szöveg:</strong> <code>original</code>
        </div>
      </div>
    </div>
  );
};

export default TextProcessorConfig;
